/** Calendar-month billing helpers (1st through last day of month). */

export const getCalendarMonthPeriod = (referenceDate = new Date()) => {
  let year;
  let monthIndex;

  if (typeof referenceDate === 'string') {
    const match = String(referenceDate).trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (match) {
      year = Number.parseInt(match[1], 10);
      monthIndex = Number.parseInt(match[2], 10) - 1;
    }
  }

  if (year == null || monthIndex == null) {
    const ref = referenceDate instanceof Date ? referenceDate : new Date(referenceDate);
    year = ref.getFullYear();
    monthIndex = ref.getMonth();
  }

  const month = String(monthIndex + 1).padStart(2, '0');
  const lastDay = new Date(year, monthIndex + 1, 0).getDate();
  const dateFrom = `${year}-${month}-01`;
  const dateTo = `${year}-${month}-${String(lastDay).padStart(2, '0')}`;

  return { dateFrom, dateTo, daysInMonth: lastDay };
};

export const getPracticeBillingPeriod = (practice) => {
  const start =
    practice?.billing_from_date ||
    practice?.rpm_start_date ||
    null;
  const end =
    practice?.billing_to_date ||
    practice?.rpm_end_date ||
    null;
  return { start, end };
};
